import React from 'react';
import { StyleSheet, View } from 'react-native';
import { s } from 'react-native-wind';
import { Button, ButtonType } from '../../../components/Button';
import { useLanguage } from '../../../locale';

interface SurveyDetailBottomBarProps {
  onSubmit: () => void;
  isSubmitting: boolean;
  isFormValid: boolean;
  isCompleted: boolean;
}

export const SurveyDetailBottomBar: React.FC<SurveyDetailBottomBarProps> = ({
  onSubmit,
  isSubmitting,
  isFormValid,
  isCompleted,
}) => {
  const [t] = useLanguage();

  return (
    <View style={[styles.container, s`bg-card`]}>
      <Button
        buttonType={ButtonType.Primary}
        isDisabled={!isFormValid || isSubmitting}
        onPress={onSubmit}
      >
        {isCompleted ? t('survey.detail.update') : t('survey.detail.submit')}
      </Button>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderTopWidth: 1,
    borderTopColor: '#E0E0E0',
  },
});
